import MarkerProps from 'Components/Action/Interface/MarkersProps';

const ProjectState: MarkerProps[] = [];

export default ProjectState;